import { render, staticRenderFns } from "./p-video.vue?vue&type=template&id=b18dc12c&scoped=true&"
import script from "./p-video.vue?vue&type=script&lang=js&"
export * from "./p-video.vue?vue&type=script&lang=js&"
import style0 from "./p-video.vue?vue&type=style&index=0&id=b18dc12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18dc12c",
  null
  
)

export default component.exports